define('ProductVariationJson.Shopping',   [
    'ProductVariationJson.Helper'
], function ProductVariationJsonShopping(
    ProductVariationJsonHelper
) {
    'use strict';

    return  {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var pdp = container.getComponent('PDP');
            var environment = container.getComponent('Environment');
            var itemOptionsMap;
            var additionalOptionsMap;
            var prodVariantJson;
            var isEnabled;
            var siteCurrency;
            var currency;
            var availabilityBackOrder;
            var shopUrl;
            if (environment && layout && pdp) {
                itemOptionsMap = environment.getConfig('acsProductVariants.itemOptionsMap');
                additionalOptionsMap = environment.getConfig('acsProductVariants.additionalOptionsMap');
                isEnabled = environment.getConfig('acsProductVariants.enable');
                siteCurrency = environment.getSiteSetting('sitecurrency') || [];
                currency = (siteCurrency.length && siteCurrency[0].code) || 'USD';
                availabilityBackOrder = environment.getConfig('structureddatamarkup.availabilityonbackorder') || 'PreOrder';
                shopUrl = environment.getSiteSetting('touchpoints.home');
                if (isEnabled) {
                    try {
                        layout.modifyViewJsonLd('ProductDetails.Full.View', function modifyJsonLd(jsonValues) {
                            if (ProductVariationJsonHelper.isMatrixItem(pdp)) {
                                prodVariantJson = ProductVariationJsonHelper.getProductVariants({
                                    pdp: pdp,
                                    jsonValues: jsonValues,
                                    itemOptionsMap: itemOptionsMap,
                                    additionalOptionsMap: additionalOptionsMap,
                                    currency: currency,
                                    availabilityBackOrder: availabilityBackOrder,
                                    shopUrl: shopUrl
                                })
                                return jQuery.Deferred().resolve(prodVariantJson);
                            }
                            return jQuery.Deferred().resolve(jsonValues);
                        });
                    } catch (error) {
                        console.warn('Error happened in ProductVariationJson.Shopping', error);
                    }
                }
            }

        }
    };
});
